module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.trackings && _vm.statistics) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card--content"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "card--header-left"
  }, [_c('strong', [_vm._v(_vm._s(_vm.leadsPerDay))]), _vm._v(" " + _vm._s(_vm.$t('statistics.leads_per_day')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "card--header-right"
  }, [_c('strong', [_vm._v(_vm._s(_vm.leadsPerDetector))]), _vm._v(" " + _vm._s(_vm.$t('statistics.leads_per_lead_detector')) + "\n      ")])]), _vm._v(" "), (_vm.trackings.resources) ? _c('div', [(_vm.leadsCount) ? _c('leads-count-chart', {
    attrs: {
      "start-date": _vm.startDate,
      "end-date": _vm.endDate,
      "leads-count": _vm.leadsCount
    }
  }) : _c('div', {
    staticClass: "is-empty"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('statistics.no_data')) + "\n      ")])], 1) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0740241d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/projects/ProjectStatisticsLeadsChart.vue
// module id = 1805
// module chunks = 0